import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { ClosedPeriodListSearchCriteria } from '../models';
import { ClosedPeriodEndpoint } from '../constants';
import { ClosedPeriodListStateModel } from './closed-period-list.state';

@Injectable({
  providedIn: 'root',
})
export class ClosedPeriodListService {
  constructor(private http: WrapperHttpService) {}

  getClosedPeriodList({
    compartmentId,
    dockId,
    searchCriteria,
  }: {
    compartmentId: number;
    dockId: number;
    searchCriteria: ClosedPeriodListSearchCriteria;
  }): Observable<ClosedPeriodListStateModel> {
    const url = `${API_URL}${ClosedPeriodEndpoint.WorkingTime}${ClosedPeriodEndpoint.Compartment}/${compartmentId}${
      dockId ? ClosedPeriodEndpoint.Dock + '/' + dockId : ''
    }${ClosedPeriodEndpoint.ClosedDays}?${getQueryStringFromObject(searchCriteria)}`;

    return this.http.withLoading().get<ClosedPeriodListStateModel>(url);
  }
}
